"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var dayjs_1 = __importDefault(require("dayjs"));
var truncateRichText_1 = __importDefault(require("../truncateRichText"));
var getFirstImage_1 = __importDefault(require("../getFirstImage"));
function createDeckCard(data) {
    var question = JSON.stringify(truncateRichText_1.default(data.question, 121));
    var card = {
        question: question,
        nextReview: dayjs_1.default(new Date()).add(1, 'day').toDate(),
        lastReview: null,
        notStarted: true,
        proficiency: 0,
        category: data.category,
        subcategories: data.subcategories,
        createdAt: new Date(),
    };
    if (data.note) {
        card.note = data.note;
    }
    var questionFirstImage = getFirstImage_1.default(data.question);
    if (questionFirstImage) {
        card.image = JSON.stringify(questionFirstImage);
    }
    return card;
}
exports.default = createDeckCard;
//# sourceMappingURL=createDeckCard.js.map